import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";
import { K1DashboardProvider } from "@/features/K1Dashboard/context/K1DashboardProvider";
import ManagementCompaniesView from "@/features/K1Dashboard/views/ManagementCompaniesView";
import K1ManagementCompaniesEdit from "./edit";

export default function K1ManagementCompanies() {
  useEffect(() => {
    setDocumentTitle("Quantilia | General Partners");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<K1ManagementCompaniesEdit />} />
      <Route
        index
        element={
          <K1DashboardProvider>
            <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
              <ManagementCompaniesView />
            </main>
          </K1DashboardProvider>
        }
      />
    </Routes>
  );
}
